export default "__VITE_ASSET__CkLIiVay__"